import PinDropIcon from '@mui/icons-material/PinDrop';
import TodayIcon from '@mui/icons-material/Today';

import { redirectToOffsegCurrentLocationPage, redirectToOffsegDailyReportPage } from '../../common/utils/redirectToOffseg';
import { redirectToG500LiteCarInfoPage } from '../../common/utils/redirectToG500Lite';
import { MenuItemListType } from '../../common/type/MenuItemListType';

export const pageName = '車両現在位置一覧';

export const lastUpdatedDatetimeName = '更新日時： ';

export const mapPopupLabel = {
	model: 'モデル：',
	carCode: '車両ID：',
	driver: 'ドライバー：',
	organization: '組織：',
	connectionStatus: '通信状態：',
};

export const connectionStatus = {
	connected: '1',
	disconnected: '0',
};

export const tableColumnList = [
	{ id: 'organizeName', label: '組織', minWidth: 70 },
	{ id: 'carCode', label: '車両番号', minWidth: 70 },
	{ id: 'numberPlate', label: 'ナンバープレート', minWidth: 80 },
	{ id: 'model', label: 'モデル', minWidth: 50 },
	{ id: 'driverName', label: 'ドライバー名', minWidth: 100 },
	{ id: 'receiveDatetime', label: '最終通信時刻', minWidth: 100 },
];

export const offsegMenuItemList: MenuItemListType = [
	{
		value: '現在位置/走行ルート/車両操作',
		name: '現在位置/走行ルート/車両操作',
		onClick: redirectToOffsegCurrentLocationPage,
		icon: PinDropIcon,
	},
	{
		value: 'ドライバー/車両日報',
		name: 'ドライバー/車両日報',
		onClick: redirectToOffsegDailyReportPage,
		icon: TodayIcon,
	},
];

export const g500LiteMenuItemList: MenuItemListType = [
	{
		value: '車両情報をみる',
		name: '車両情報をみる',
		onClick: redirectToG500LiteCarInfoPage,
		icon: PinDropIcon,
	},
];

export const exampleLabel = {
	connected: '：接続状態',
	disconnected: '：非接続状態',
};
